import React, { useEffect, useState } from "react";
import { Form, Spin, Divider, Input } from "antd";
import { ReactSVG } from "react-svg";

import "./Brand.scss";
import ImageUploader from "../../Upload/Image";
import ColorPicker from "../../Elements/ColorPicker";
import PrimaryButton from "../../Buttons/PrimaryButton";
import { getTranslation } from "../../../utils/helper";

const BrandSettingsForm = ({ setting, doUpdateBrandSetting }) => {
  const [form] = Form.useForm();
  const [logo, setLogo] = useState({});
  const [previewImage, setPreviewImage] = useState("");
  const [colorPicker, setColorPicker] = useState("#7732EF" || "");
  const [isRemoveLogo, setIsRemoveLogo] = useState(false);

  const handleOnFinish = () => {
    const formData = new FormData();
    if (typeof logo !== "string") {
      const newLogo = logo ? logo : null;
      formData.append("file", newLogo);
    }
    formData.append("primaryColor", colorPicker);
    formData.append("logoDeleted", isRemoveLogo);
    doUpdateBrandSetting(formData);
    setIsRemoveLogo(false);
  };

  const onColerPickerChange = value => {
    setColorPicker(value);
  };

  const onColorPickerInputChange = event => {
    const { value } = event.target;
    setColorPicker(value);
  };

  const handleRemoveLogo = value => {
    setIsRemoveLogo(value);
  };

  useEffect(() => {
    if (setting) {
      setColorPicker(setting?.primaryColor);
      setPreviewImage(setting?.logo);
      form.setFieldsValue({
        logo: setting?.logo,
        primaryColor: setting?.primaryColor,
        logo: { fileList: setting?.logo ? [setting?.logo] : [] },
      });
      setting?.logo && setLogo(setting?.logo);
    } else {
      setLogo({});
      setPreviewImage("");
    }
  }, [setting]);

  return (
    <Spin spinning={false}>
      <div className="SettingsForm BrandSettingsForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
          <div className="FormContent">
            <div className="FormContent__label">{getTranslation(setting, "Settings", "Company Logo")}</div>
            <Form.Item>
              <ImageUploader
                name="logo"
                image={logo}
                setImage={setLogo}
                isRequired={false}
                setPreviewImage={setPreviewImage}
                previewImage={previewImage}
                handleRemoveLogo={handleRemoveLogo}
              />
            </Form.Item>
            <Divider />
            <div className="FormContent__label">{getTranslation(setting, "Settings", "Primary Color")}</div>
            <div className="primary-color-section">
              <Form.Item label="Color Hex Code" name="primaryColor" className="color-picker-input">
                <Input value={colorPicker} onChange={onColorPickerInputChange} />
                <ColorPicker colorPicker={colorPicker} onColerPickerChange={onColerPickerChange} />
              </Form.Item>
            </div>
          </div>
          <Divider />
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <PrimaryButton
                label={getTranslation(setting, "Common", "Update")}
                htmlType="submit"
                icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
              />
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BrandSettingsForm;
